import { useDispatch, useSelector } from "react-redux";
import { useToast } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import GDeleteModal from "components/ui/modal/DeleteModal";
import { deleteTax } from "../../services/taxesService";

const DeleteModal = ({
  data,
  onClose
}) => {
  const { t } = useTranslation();
  const toast = useToast({ position: "top", duration: 3000, status: "success" });
  const dispatch = useDispatch();
  const taxes = useSelector(state => state.taxes);

  return (
    <GDeleteModal
      onClose={onClose}
      onSubmit={() => {
        dispatch(deleteTax({ id: data.id }))
          .unwrap()
          .then(_ => {
            toast({ description: t("pages.taxes.tax_deleted") });
            onClose();
          })
      }}
      isLoading={taxes.isLoading}
    />
  )
}

export default DeleteModal